import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

const apiUrl = '/api/statistics';

@Injectable({ providedIn: 'root' })
export class StatisticsService {
  constructor(private readonly http: HttpClient) {}

  getAggregated(from: Date, to: Date, provider?: string): Observable<any[]> {
    let params = `from=${from.toISOString()}&to=${to.toISOString()}`;
    if (provider) {
      params += `&provider=${provider}`;
    }
    return this.http
      .get<any[]>(`${apiUrl}/aggregated?${params}`)
      .pipe(catchError(() => of([])));
  }

  getMarkers(from: Date, to: Date): Observable<any[]> {
    return this.http
      .get<any[]>(
        `${apiUrl}/markers?from=${from.toISOString()}&to=${to.toISOString()}`,
      )
      .pipe(catchError(() => of([])));
  }

  getMetrics(from: Date, to: Date, provider?: string): Observable<any[]> {
    let params = `from=${from.toISOString()}&to=${to.toISOString()}`;
    if (provider) {
      params += `&provider=${provider}`;
    }
    return this.http
      .get<any[]>(`${apiUrl}/metrics?${params}`)
      .pipe(catchError(() => of([])));
  }

  getQueues(): Observable<any> {
    return this.http
      .get<any>(`${apiUrl}/queues`)
      .pipe(catchError(() => of({ needsReload: 0, needsInpostReload: 0 })));
  }

  getRecent(limit: number = 50): Observable<any[]> {
    return this.http
      .get<any[]>(`${apiUrl}/recent?limit=${limit}`)
      .pipe(catchError(() => of([])));
  }

  getCriticalErrors(limit: number = 100): Observable<any[]> {
    return this.http
      .get<any[]>(`${apiUrl}/critical-errors?limit=${limit}`)
      .pipe(catchError(() => of([])));
  }

  getInpostRateLimit(): Observable<any> {
    return this.http
      .get<any>('/api/inpost/rate-limit')
      .pipe(catchError(() => of(null)));
  }

  resolveCriticalError(id: string): Observable<any> {
    return this.http
      .patch<any>(`${apiUrl}/critical-errors/${id}/resolve`, {})
      .pipe(catchError(() => of(null)));
  }
}
